import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { setTracker } from '~/Redux/Modules/DayTrackers';
import WaterTracking from '~/Containers/Global/Water/WaterTracking';
import MealPrep from '~/Containers/Global/MealPrep/MealPrep';
import { generateWeek } from '~/Context/Global';
import { MUST_DO, OTHER, CUSTOM, MONTH_TODO, WEEK_TODO } from '~/Config/Checklists';
import { DAY, WEEK, MONTH } from '~/Config/DateRangeTypes';
import { TaskList, CustomTaskList } from '~/Components/Pages/Calendar/Tasks';
import { toStartOfWeekForChecklist } from '~/Context/Checklist';
import AppFeatureView, { HABIT_TRACKER } from '~/Components/Global/AppFeatureView';

import './MobileTrayItems.scss';
import HabitDayTracking from '~/Components/Pages/Habits/HabitDayTracking';

export class MobileTrayItems extends Component {
  generateMealPreps = () => {
    const { currentDate } = this.props;
    return generateWeek(currentDate).map((day, index) => {
      return (
        <div key={index} id="mobile-meal-prep" className="tray-item-wrapper">
          <div className="tray-item">
            <MealPrep date={day} header="MEALS" suffix={day.format('ddd, DD')} />
          </div>
        </div>
      );
    });
  };

  render() {
    const { currentType, currentDate, activeTracker } = this.props;
    return (
      <div className="mobile-tray-items">
        {currentType === MONTH && (
          <div id="mobile-todo" className="tray-item-wrapper">
            <div className="tray-item">
              <TaskList date={currentDate} type={MONTH_TODO} header="MONTHLY GOALS" />
            </div>
          </div>
        )}
        {currentType === WEEK && [
          <div key="a" id="mobile-todo" className="tray-item-wrapper">
            <div className="tray-item">
              <TaskList
                date={toStartOfWeekForChecklist(currentDate)}
                type={WEEK_TODO}
                header="GOALS"
              />
            </div>
          </div>,
          this.generateMealPreps(),
        ]}
        {currentType === DAY && [
          <div key="a" className="tray-item-wrapper">
            <div key="a" className="tray-item-target" id="mobile-todo" />
            <div key="b" className="tray-item">
              <TaskList date={currentDate} type={MUST_DO} header="PRIORITY TASKS" editableHeader />
            </div>
          </div>,
          <div key="b" className="tray-item-wrapper">
            <div className="tray-item">
              <TaskList date={currentDate} type={OTHER} header="OTHER TASKS" editableHeader />
            </div>
          </div>,
          <div key="c" className="tray-item-wrapper">
            <div className="tray-item">
              <CustomTaskList date={currentDate} type={CUSTOM} />
            </div>
          </div>,
          <div key="d" className="tray-item-wrapper">
            <div key="a" className="tray-item-target" id="mobile-meal-prep" />
            <div key="b" className="tray-item">
              <MealPrep editableHeader />
            </div>
          </div>,
          <AppFeatureView
            featureName={HABIT_TRACKER}
            disabledView={
              <div key="e" className="tray-item-wrapper">
                <div key="a" className="tray-item-target" id="mobile-water-tracking" />
                <div key="b" className="tray-item">
                  <WaterTracking />
                </div>
              </div>
            }
          >
            {activeTracker === 'habit' ? (
              <div key="e" className="tray-item-wrapper">
                <div key="a" className="tray-item-target" id="mobile-habit-tracking" />
                <div key="b" className="tray-item">
                  <HabitDayTracking />
                </div>
              </div>
            ) : (
              <div key="e" className="tray-item-wrapper">
                <div key="a" className="tray-item-target" id="mobile-water-tracking" />
                <div key="b" className="tray-item">
                  <WaterTracking />
                </div>
              </div>
            )}
            ,
          </AppFeatureView>,
        ]}
      </div>
    );
  }
}

MobileTrayItems.propTypes = {
  currentDate: propTypes.object,
  currentType: propTypes.string,
  setTracker: propTypes.func,
  activeTracker: propTypes.string,
};

const mapStateToProps = ({ DateRange, DayTrackers }) => {
  return {
    currentDate: DateRange.start,
    currentType: DateRange.currentType,
    activeTracker: DayTrackers.activeTracker,
  };
};

const mapDispatchToProps = dispatch => ({
  setTracker: opt => dispatch(setTracker(opt)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileTrayItems);
